/* unplugin-vue-components disabled */import __unplugin_components_0 from 'D:/htdocs/gitlab_project/laravel/mukiPailung/frontend/src/components/form/HomeBaseInput.vue';
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/images/logo/logo.svg';
const _withScopeId = n => (_pushScopeId("data-v-88079b62"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "",
  srcset: ""
}, null, -1));
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Mechanical Service System", -1));
const _hoisted_3 = {
  class: "form-list"
};
const _hoisted_4 = {
  style: {
    "margin-bottom": "20px"
  }
};
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "員工編號 Technician ID", -1));
const _hoisted_6 = {
  style: {
    "margin-bottom": "30px"
  }
};
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "密碼 Password", -1));
import { useI18n } from "vue-i18n";
import { useForm } from "vee-validate";
import { baseGet, basePost, Staff } from "@/js/services/baseService";
import store from "@/store/store.js";
import { ajax200Res } from '@/js/utils';
import * as yup from "yup";
// import { basePost, postLogin } from "@/js/services/baseService";

export default {
  __name: 'Login',
  setup(__props) {
    const pageData = reactive({
      account: "",
      password: ""
    });
    const passwordRegExp = /^[A-Za-z0-9]{6,20}$/;
    const {
      t
    } = useI18n();
    const validationSchema = yup.object({
      code: yup.string().required('必填 Required'),
      password: yup.string()
      // .matches(passwordRegExp, "請輸入6~20碼，英文或數字")
      .required('必填 Required')
    });
    const {
      values,
      handleSubmit
    } = useForm({
      validationSchema
    });
    function afterin() {
      f7.params.dialog.buttonOk = 'OK';
    }
    function afterout() {
      f7.params.dialog.buttonOk = t('dialog.buttonOk');
    }
    const login = handleSubmit(async () => {
      Staff.login(values).then(res => {
        const {
          onSuccess,
          onFail
        } = ajax200Res(res);
        onSuccess(({
          res,
          data,
          msg,
          defaultAlert
        }) => {
          _alert_custom('提示 Notification', msg, function () {
            localStorage.setItem('staffPermissions', data.content.permissions);
            localStorage.setItem('staffName', data.content.name);
            localStorage.setItem('staffCode', data.content.code);
            let staff = {
              id: data.content.id,
              name: data.content.name,
              code: data.content.code,
              ordersPermission: data.content.permissions.includes(1),
              muPermission: data.content.permissions.includes(2)
            };
            store.commit('updateStaff', staff);
            let staffPermissions = localStorage.getItem("staffPermissions");
            if (staffPermissions.includes('1')) {
              _direct_page('/');
            } else {
              _direct_page('/Inquire');
            }
          });
        });
        onFail(({
          res,
          data,
          msg,
          defaultAlert
        }) => {
          _alert_custom('提示 Notification', msg, function () {});
        });
      });
    });
    return (_ctx, _cache) => {
      const _component_f7_block = _resolveComponent("f7-block");
      const _component_f7_icon = _resolveComponent("f7-icon");
      const _component_HomeBaseInput = __unplugin_components_0;
      const _component_f7_button = _resolveComponent("f7-button");
      const _component_f7_page = _resolveComponent("f7-page");
      return _openBlock(), _createBlock(_component_f7_page, {
        name: "login",
        class: "p-login",
        "no-toolbar": "",
        "page-content": false,
        "onPage:afterin": afterin,
        "onPage:afterout": afterout
      }, {
        default: _withCtx(() => [_createVNode(_component_f7_block, {
          class: "header"
        }, {
          default: _withCtx(() => [_hoisted_1, _hoisted_2]),
          _: 1
        }), _createVNode(_component_f7_block, null, {
          default: _withCtx(() => [_createElementVNode("form", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_hoisted_5, _createVNode(_component_HomeBaseInput, {
            name: "code",
            placeholder: "請輸入員工編號  Enter technician ID",
            modelValue: _unref(pageData).mobile,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _unref(pageData).mobile = $event)
          }, {
            before: _withCtx(() => [_createVNode(_component_f7_icon, {
              icon: "icon-user",
              size: "18px",
              style: {
                "margin-right": "10px"
              },
              color: "primary"
            })]),
            _: 1
          }, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_6, [_hoisted_7, _createVNode(_component_HomeBaseInput, {
            name: "password",
            type: "password",
            placeholder: "請輸入密碼  Enter password",
            modelValue: _unref(pageData).password,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _unref(pageData).password = $event),
            isShowPassword: ""
          }, {
            before: _withCtx(() => [_createVNode(_component_f7_icon, {
              icon: "icon-lock",
              size: "18px",
              style: {
                "margin-right": "10px"
              },
              color: "primary"
            })]),
            _: 1
          }, 8, ["modelValue"])]), _createElementVNode("div", null, [_createVNode(_component_f7_button, {
            fill: "",
            large: "",
            onClick: _unref(login)
          }, {
            default: _withCtx(() => [_createTextVNode("登入 LOG IN")]),
            _: 1
          }, 8, ["onClick"])])])]),
          _: 1
        })]),
        _: 1
      });
    };
  }
};